export function checkNull(value) {
  if (value === null) return "none";
  return value;
}
